import ListRoles from "./List";
import { AccountServicePath, ROLES } from "utils/constants";
import permissions from "app/permissions";
import LockIcon from "@mui/icons-material/Lock";
import CreateRole from "./Create";
import EditRole from "./Edit";

//permissions
export const resources = {
  isMenu: true,
  icon: <LockIcon />,
  name: AccountServicePath + ROLES,
  title: "Роли",
  list: <ListRoles />,
  create: <CreateRole />,
  createPermission: permissions.canCreateRoles,
  edit: <EditRole />,
  editPermission: permissions.canUpdateRoles,
  permission: permissions.canPreviewRoles,
};
